/*eslint-disable @typescript-eslint/no-unused-vars */
import React, { memo, useCallback, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../rmsReduxStore/rmsReduxHooks';
import { exportInventoryParamReport, fetchChargerInventoryParameters, getChargerReducer } from '../../../rmsReduxStore/reduxExports';
import { useLocation } from 'react-router-dom';
import { TableSubHeader, downloadFile } from '../../../globalUtils/globalExports';
import { renderHeaderActionButtons, useEffectOnce } from '../../../globalUtils/globalHooks';
import { Menu, MenuItem } from '@mui/material';
import { toast } from 'react-toastify';
import './chargerPanelInventoryParametersDashboard.css';
import InventorySection from './ChargerPanelInventoryParameters/InventorySection';
import CustomChartPopup from '../../softwareReleaseManagement/dashboard/CustomChartPopup';
import ChargerInventoryParameterChangeLogDashboard from './ChargerPanelInventoryParameters/ChargerInventoryParameterChangeLogDashboard';

interface ChargerPanelInventoryParametersProps {
  contentHeight: number
}


const ChargerPanelInventoryParametersDashboard = memo(function ChargerPanelInventoryParametersDashboard({ contentHeight }: ChargerPanelInventoryParametersProps) {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [exportAnchorEl, setExportAnchorEl] = useState<HTMLElement | null>(null);
  const [exportingFile, setExportingFile] = useState(false);
  const {chargerInventoryParameters, chargerInventoryParametersCount}  = useAppSelector(getChargerReducer);
  const [expandChangeLogsDashboard,setExpandChangeLogsDashboard] = useState(false);

  const headerActionBtns = renderHeaderActionButtons({
    actionBtns:
      [
        {
          id: 'change_log_btn',
          isAccessible: true,
          headerActionBtnClick: (event): void => {
            setExpandChangeLogsDashboard(true);
          }
        },
        {

          id: 'export_csv_btn',
          isAccessible: true,
          headerActionBtnClick: (event): void => {
           setExportAnchorEl(event.currentTarget);
          }
        },
      ]
  });

  const handleClose = useCallback(() => {
    setExportAnchorEl(null);
  }, []);

  const onExportBtnClick = useCallback(async (fileType: string) => {
    if (exportingFile) return;
    setExportingFile(true);

    try {
      const response = await dispatch(exportInventoryParamReport({
        fileType,
        chargerId: location?.state?.chargerId,
        sortBy: null,
        order: null
      }));
      if (response?.status === 200 || response?.status === 202) {
        downloadFile({ url: response?.data?.url });
        toast.success('File downloaded.');
      } else {
        toast.warn('Something went wrong. Please export again.');
      }
    } finally {
      setExportingFile(false);
      setExportAnchorEl(null);
    }
  }, [exportingFile, location, handleClose]);


  useEffectOnce(()=> {
    dispatch(fetchChargerInventoryParameters({ chargerId: location?.state?.chargerId }))
  })
  
  return (
    <div className='charger__panel__inventory__param__dashboard__container' style={{ height: `${contentHeight}px` }}>
        <div className='charger__panel__inventory__param__dashboard__header'>
          <div className='charger__panel__inventory__param__dashboard__header__button__wrap'>
              <div className='charger__panel__inventory__param__components__count__indicator'>
                <div className='charger__panel__inventory__param__components__count__indicator__icon'></div>
                <div className='charger__panel__inventory__param__components__count__indicator__text'>Total: {chargerInventoryParametersCount ?? 0} components</div>
              </div>
              <div className='charger__panel__inventory__param__dashboard__header__button__container'>
                 <TableSubHeader headerActionBtns={headerActionBtns}/>
              </div>
          </div>
        </div>
        <div className='charger__panel__inventory__param__dashboard__body'>
            {/* System Level Components */}
            <InventorySection icon={'inventory_parameter_system_level_component_icon'} label={'SYSTEM LEVEL'} componentCount={chargerInventoryParameters?.systemLevelComponents?.length ?? 0} type={'system'} componentList={chargerInventoryParameters?.systemLevelComponents ?? []} />
            {/* SMR Components */}
            <InventorySection icon={'rms_thunderbolt_icon'} label={'SMR - POWER MODULES'} componentCount={chargerInventoryParameters?.smrLevelComponents?.length ?? 0} type={'smr'} componentList={chargerInventoryParameters?.smrLevelComponents ?? []} />
            {/* Connector Components */}
            <InventorySection icon={'rms_thunderbolt_icon'} label={'CONNECTOR LEVEL'} componentCount={chargerInventoryParameters?.connectorLevelComponents?.length ?? 0} type={'connector'} componentList={chargerInventoryParameters?.connectorLevelComponents ?? []} />
        </div>
        <>
          <Menu
              id="export-option-dropdown"
              anchorEl={exportAnchorEl}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              keepMounted
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              className='export__option__dropdown'
              sx={{ top: '30px' }}
              open={Boolean(exportAnchorEl)}
              onClose={handleClose}
            >
              <MenuItem>
                <div className='export__btn-option' onClick={(e) => { e?.stopPropagation(); onExportBtnClick('csv'); }}>
                  To CSV
                </div>
              </MenuItem>
              <MenuItem>
                <div className='export__btn-option' onClick={(e) => { e?.stopPropagation(); onExportBtnClick('xlsx'); }}>
                  To Excel
                </div>
              </MenuItem>
          </Menu>
        </>
        <>
          <CustomChartPopup
            show={expandChangeLogsDashboard}
            handleClose={() => setExpandChangeLogsDashboard(false)}
          >
            <ChargerInventoryParameterChangeLogDashboard handleCloseIconClicked = {() => setExpandChangeLogsDashboard(false)} />
          </CustomChartPopup>
        </>
    </div>
  );
});

export default ChargerPanelInventoryParametersDashboard;

